import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AppContext from '../../../context/AppContext';
import '../../../assets/css/customer/packages/Weddingpriceguide.css';

const WeddingPricingGuide = () => {
  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);

  const [packages, setPackages] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [loadingId, setLoadingId] = useState(null); 

  const parseList = (val) => {
    if (!val || val === 'null') return [];
    try {
      const parsed = JSON.parse(val);
      if (!parsed) return [];
      return Array.isArray(parsed) ? parsed : [String(parsed)];
    } catch {
      return String(val).split(',').map(s => s.trim()).filter(Boolean);
    }
  };

  const viewAllPackages = () => {
    axios.get(`${baseUrl}/packages/viewAllPackages`)
    .then((res) => {
      if (res.data.status === true) {
        setPackages(res.data.packages);
      }
      setPageLoading(false);
    })
    .catch((err) => {
      console.log("viewAllPackages error:", err);
      setPageLoading(false);
    });
  };

  useEffect(() => {
    viewAllPackages();
  }, []);

  const handleViewDetails = (pkg) => {
    setLoadingId(pkg.id); 
    setTimeout(() => {
      navigate('/packagesdetail', { state: { package: pkg } });
      setLoadingId(null);
    }, 600);
  };

  return (
    <section className="wpg-section">
      <Container fluid="lg">

        <Row className="wpg-heading-row">
          <Col xs={12} className="wpg-heading-col">
            <div className="wpg-title-block">
              <p className="wpg-keep-the">keep the</p>
              <span className="wpg-planner">planner</span>
            </div>
            <p className="wpg-wedding-package">WEDDING PACKAGE</p>
            <p className="wpg-pricing-guide">Pricing Guide</p>
          </Col>
        </Row>

        {pageLoading ? (
          <Row>
            <Col xs={12} className="text-center" style={{ padding: "40px 0" }}>
              Loading packages...
            </Col>
          </Row>
        ) : (
          <Row className="wpg-cards-row justify-content-center">
            {packages.length === 0 && (
              <Col xs={12} className="text-center" style={{ padding: "40px 0" }}>
                No packages found
              </Col>
            )}
            {packages.map((pkg, index) => {
              const features = parseList(pkg.features);
              const isPopular = index === 1;

              return (
                <Col key={pkg.id} xs={12} md={6} lg={4} className="wpg-card-col">
                  <div className={`wpg-card ${isPopular ? 'wpg-card-popular' : ''}`}>

                    <div className="wpg-card-header">
                      <h3 className="wpg-package-name">{pkg.name}</h3>
                      <span className="wpg-package-price">
                        {pkg.packagePrice && pkg.packagePrice !== 'null' ? `PKR ${pkg.packagePrice}` : 'Price on request'}
                      </span>
                      {isPopular && (
                        <p className="wpg-most-popular">most popular</p>
                      )}
                    </div>

                    <hr className="wpg-divider" />

                    <ul className="wpg-features-list">
                      {features.map((feature, fIndex) => (
                        <li key={fIndex} className="wpg-feature-item">
                          {feature}
                        </li>
                      ))}
                    </ul>

                    <div className="wpg-button-wrapper">
                      <Button
                        className={`wpg-book-button ${isPopular ? 'wpg-book-button-popular' : ''}`}
                        disabled={loadingId === pkg.id}
                        onClick={() => handleViewDetails(pkg)}
                      >
                        {loadingId === pkg.id ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                            Loading...
                          </>
                        ) : (
                          'View Details'
                        )}
                      </Button>
                    </div>
                  </div>
                </Col>
              );
            })}
          </Row>
        )}

      </Container>
    </section>
  );
};

export default WeddingPricingGuide;